<template>
    <div class="warpper padding-sm bg-white">
        <div class="flex align-center justify-between margin-bottom-sm ">
            <b class="page-title line-height">{{name}}</b>
            <el-button class="blue-btn" round type="primary" @click="$router.go(-1)">返回</el-button>
        </div>
        <VueUditorWrap
            class="margin-top"
            v-model="defaultMsg"
            :config="myConfig"
            v-if="user.isBranch"
        ></VueUditorWrap>
        <div  class="margin-top" v-html="defaultMsg" v-else></div>
        <div class="flex justify-center margin" v-if="user.isBranch">
            <el-button class="blue-btn big-btn"  @click="submission">保存</el-button>
        </div>
    </div>
</template>

<script>
import VueUditorWrap from "vue-ueditor-wrap";
import {bdEditConfig} from "@/utils/utils";
import {getBasesArticleData,saveBasesArticleData} from "@/api/branch";
export default {
    name: "label",
    data() {
        return {
            id: '',
            type: '',
            title: '',
            defaultMsg: '',
            myConfig: bdEditConfig(),
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [2, 4], '会员说明')
        this.name = this.$route.params.name
        this.type = this.$route.params.type
        this.init()
    },
    components: {
        VueUditorWrap
    },
    methods: {
        // 获取详情
        async init() {
            let _data = await getBasesArticleData('',this.user.fhid,this.type)
            this.defaultMsg = _data.data.content
        },
        // 说明编辑保存
        async submission() {
            if (!this.defaultMsg)   return this.$message.error('请输入内容')
            let _data = await saveBasesArticleData('',this.user.fhid,this.type,this.title,this.defaultMsg)
            this.$message.success(_data.msg);
            this.$router.go(-1)
        }
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    .page-list {
        .item {
            width: 100%;
            border: solid 1px #e8e8e8;

            .header {
                height: 68px;
                background-color: #f4f4f4;
                border-bottom: solid 1px #e8e8e8;

                .title {
                    font-size: 16px;
                    font-weight: bold;
                    color: #333333;

                    i {
                        font-size: 20px;
                        color: #0a2240;
                        margin-right: 10px;
                    }
                }
            }

            .child {
                height: 68px;
                background-color: #ffffff;
                padding: 0 28px;

                .title {
                    font-size: 14px;
                    padding-left: 65px;
                    color: #333333;
                }
            }

            .sort {
                font-size: 14px;
                color: #0a2240;

                span {
                    background-color: #ffffff;
                    border-radius: 6px;
                    border: solid 1px #e8e8e8;
                    font-size: 14px;
                    color: #999999;
                    padding: 10px 15px;
                }
            }

            .operate {
                width: 60px;
                height: 34px;
                border-radius: 20px;
                border: solid 1px #0a2240;
                font-size: 14px;
                padding: 0;
                background-color: #0a2240;
                color: #ffffff;

                &.line {
                    background-color: #ffffff;
                    color: #0a2240;
                }

                &.active {
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#29c16d, #29c16d);
                    background-blend-mode: normal, normal;
                    border: none;
                }
            }
        }
    }

    .input-container {
        .el-select {
            width: 100%;
        }
    }
}
</style>